import React, { useState, useRef, useEffect } from "react";
import { Dropdown, Row, Nav, Tab, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from "react-select";
import PageTitle from "../../layouts/PageTitle";
import { IMAGES } from "../../constant/theme";
import { gridDataBlog } from "../staff/GridData";
import { DatePicker } from "rsuite";

const holidayTable = [
  {
    id: 1,
    scheduledDate: "2025/11/01",
    tournamentName: "Practice Match",
    teamName: "Team 1",
    reportingTime: "07:30 AM",
  },
  {
    id: 2,
    scheduledDate: "2025/11/05",
    tournamentName: "Practice Match",
    teamName: "Team 2",
    reportingTime: "09:00 AM",
  },
  {
    id: 3,
    scheduledDate: "2025/11/10",
    tournamentName: "Practice Match",
    teamName: "Team 3",
    reportingTime: "06:00 AM",
  },
  {
    id: 4,
    scheduledDate: "2025/11/15",
    tournamentName: "Practice Match",
    teamName: "Team 4",
    reportingTime: "08:30 AM",
  },
  {
    id: 5,
    scheduledDate: "2025/11/18",
    tournamentName: "Practice Match",
    teamName: "Team 5",
    reportingTime: "07:45 AM",
  },
  {
    id: 6,
    scheduledDate: "2025/11/20",
    tournamentName: "Practice Match",
    teamName: "Team 6",
    reportingTime: "08:00 AM",
  },
  {
    id: 7,
    scheduledDate: "2025/11/25",
    tournamentName: "Practice Match",
    teamName: "Teams 7",
    reportingTime: "06:30 AM",
  },
  {
    id: 8,
    scheduledDate: "2025/11/30",
    tournamentName: "Practice Match",
    teamName: "Team 8",
    reportingTime: "09:00 AM",
  },
];

const theadData = [
  { heading: "S.No.", sortingVale: "sno" },
  { heading: "Team Name", sortingVale: "teamName" },
  { heading: "Tournament Name", sortingVale: "tournamentName" },
  { heading: "Schedule Date", sortingVale: "scheduledDate" },
  { heading: "Action", sortingVale: "action" },
];

const AllTeams = () => {
  const [largeModal, setLargeModal] = useState(false);
  const [sort, setSortata] = useState(10);
  const [data, setData] = useState(
    document.querySelectorAll("#holidayList tbody tr")
  );

  const activePag = useRef(0);
  const [test, settest] = useState(0);

  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };

  useEffect(() => {
    setData(document.querySelectorAll("#holidayList tbody tr"));
  }, [test]);

  activePag.current === 0 && chageData(0, sort);

  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  const [feeData, setFeeDate] = useState([...holidayTable]);
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  function SotingData(name) {
    const sortedPeople = [...feeData];
    switch (name) {
      case "rollno":
        sortedPeople.sort((a, b) => {
          return a.rollno < b.rollno ? -1 : 1;
        });
        break;
      case "name":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name);
        });
        break;
      case "education":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.education.localeCompare(b.education)
            : b.education.localeCompare(a.education);
        });
        break;
      case "mobile":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.mobile.localeCompare(b.mobile)
            : b.mobile.localeCompare(a.mobile);
        });
        break;
      case "join":
        sortedPeople.sort((a, b) => {
          return iconData.complete
            ? a.join.localeCompare(b.join)
            : b.join.localeCompare(a.join);
        });
        break;
      default:
        break;
    }
    setFeeDate(sortedPeople);
  }
  function DataSearch(e) {
    const updatesDate = holidayTable.filter((item) => {
      let selectdata =
        `${item.name} ${item.join} ${item.education} ${item.mobile}`.toLowerCase();
      return selectdata.includes(e.target.value.toLowerCase());
    });
    setFeeDate([...updatesDate]);
  }
  return (
    <>
      <PageTitle activeMenu={"All Teams"} motherMenu={"Tournaments"} />
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Nav as="ul" className="nav nav-pills mb-3">
              <Nav.Item as="li">
                <Nav.Link eventKey="List" className="me-1">
                  List View
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li">
                <Nav.Link eventKey="Grid">Grid View</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">All Teams List </h4>
                    <Button
                      className="btn btn-primary"
                      onClick={() => setLargeModal(true)}
                    >
                      + Add New
                    </Button>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="holidayList"
                        className="dataTables_wrapper no-footer"
                      >
                        <div className="justify-content-between d-sm-flex">
                          <div className="dataTables_length">
                            <label className="d-flex align-items-center">
                              Show
                              <Dropdown className="search-drop">
                                <Dropdown.Toggle
                                  as="div"
                                  className="search-drop-btn"
                                >
                                  {sort}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={() => setSortata("10")}
                                  >
                                    10
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => setSortata("20")}
                                  >
                                    20
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    onClick={() => setSortata("30")}
                                  >
                                    30
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                              entries
                            </label>
                          </div>
                          <div className="dataTables_filter">
                            <label>
                              Search :{" "}
                              <input
                                type="search"
                                className=""
                                placeholder=""
                                onChange={DataSearch}
                              />
                            </label>
                          </div>
                        </div>
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                >
                                  {item.heading}
                                  <span>
                                    {ind !== iconData.ind && (
                                      <i
                                        className="fa fa-sort ms-2 fs-12"
                                        style={{ opacity: "0.3" }}
                                      />
                                    )}
                                    {ind === iconData.ind &&
                                      (iconData.complete ? (
                                        <i
                                          className="fa fa-arrow-down ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ) : (
                                        <i
                                          className="fa fa-arrow-up ms-2 fs-12"
                                          style={{ opacity: "0.7" }}
                                        />
                                      ))}
                                  </span>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {feeData.map((data, ind) => (
                              <tr key={ind}>
                                <td>{data.id}</td>

                                <td>{data.teamName}</td>
                                <td>{data.tournamentName}</td>
                                <td>
                                  <strong>{data.scheduledDate}</strong>
                                </td>
                                <td>
                                  <Link
                                    to={"#"}
                                    className="btn btn-xs sharp btn-primary me-1"
                                  >
                                    <i className="fa fa-pencil" />
                                  </Link>
                                  <Link
                                    to={"#"}
                                    className="btn btn-xs sharp btn-danger"
                                  >
                                    <i className="fa fa-trash" />
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing {activePag.current * sort + 1} to{" "}
                            {data.length > (activePag.current + 1) * sort
                              ? (activePag.current + 1) * sort
                              : data.length}{" "}
                            of {data.length} entries
                          </div>
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="example5_paginate"
                          >
                            <Link
                              className="paginate_button previous disabled"
                              to="#"
                              onClick={() =>
                                activePag.current > 0 &&
                                onClick(activePag.current - 1)
                              }
                            >
                              Previous
                            </Link>
                            <span>
                              {paggination.map((number, i) => (
                                <Link
                                  key={i}
                                  to="#"
                                  className={`paginate_button  ${
                                    activePag.current === i ? "current" : ""
                                  } `}
                                  onClick={() => onClick(i)}
                                >
                                  {number}
                                </Link>
                              ))}
                            </span>
                            <Link
                              className="paginate_button next"
                              to="#"
                              onClick={() =>
                                activePag.current + 1 < paggination.length &&
                                onClick(activePag.current + 1)
                              }
                            >
                              Next
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="Grid" className="col-lg-12">
                <div className="row">
                  {gridDataBlog.map((item, ind) => (
                    <div
                      className="col-lg-4 col-md-6 col-sm-6 col-12"
                      key={ind}
                    >
                      <div className="card card-profile">
                        <div className="card-header justify-content-end pb-0 border-0">
                          <Dropdown>
                            <Dropdown.Toggle
                              as="button"
                              className="btn btn-link i-false"
                              type="button"
                            >
                              <span className="dropdown-dots fs--1"></span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              align="end"
                              className="dropdown-menu dropdown-menu-right border py-0"
                            >
                              <div className="py-2">
                                <Link to={"#"} className="dropdown-item">
                                  Edit
                                </Link>
                                <Link
                                  to={"#"}
                                  className="dropdown-item text-danger"
                                >
                                  Delete
                                </Link>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="card-body pt-2">
                          <div className="text-center">
                            <div className="profile-photo">
                              <img
                                src={item.image}
                                width="100"
                                className="img-fluid rounded-circle"
                                alt=""
                              />
                            </div>
                            <h3 className="mt-4 mb-1">{item.name}</h3>
                            <p className="text-muted">{item.subject}</p>
                            <ul className="list-group mb-3 list-group-flush">
                              {item.content.map((data, ind) => (
                                <li
                                  className="list-group-item px-0 d-flex justify-content-between"
                                  key={ind}
                                >
                                  <span className="mb-0">{data.title} :</span>
                                  <strong>{data.subtitle}</strong>
                                </li>
                              ))}
                            </ul>
                            <Link
                              to={"/about-student"}
                              className="btn btn-outline-primary btn-rounded mt-3 px-4"
                            >
                              Read More
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>

      <Modal
        className="fade bd-example-modal-lg"
        show={largeModal}
        size="lg"
        onHide={setLargeModal}
      >
        <Modal.Header>
          <Modal.Title>Add Team</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setLargeModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body">
            <form>
              <div className="row">
                {/* Tournament Name */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="tournamentName">
                      Name
                    </label>
                    <input
                      id="tournamentName"
                      placeholder="Enter Tournament or Practice Name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                {/* Ball Type */}
                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label">Tournament</label>
                    <Select
                      isSearchable={false}
                      options={[
                        { value: "1", label: "Practice Match" },
                        { value: "2", label: "Interclub Tournament" },
                        { value: "3", label: "City League Finals" },
                      ]}
                      placeholder="Select Tournament"
                      className="custom-react-select"
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="matchDate">
                      Schedule Date
                    </label>
                    <div className="input-hasicon mb-xl-0 mb-3">
                      <DatePicker
                        placeholder="Select Schedule Date"
                        className="picker-suit"
                      />
                      <div className="icon">
                        <i className="far fa-calendar" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger light" onClick={() => setLargeModal(false)}>
            Close
          </Button>
          <Button variant="" type="button" className="btn btn-primary">
            Save changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AllTeams;
